import React, { useEffect, useState } from "react";
import Cartstatus from "../cart/Cartstatus";
import Cartform from "../cart/Cartform";
import { useTranslation } from "react-i18next";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import CustomCurrencyFormat from "../utils/CurrencyFormat";
import dollars from '../../assets/images/dollars.png';

function Carttotal(props) {
  const [gst, setGST] = useState(0);
  const { t } = useTranslation();
  const { subtotal, grand_total, tax_amount, discount } = props.cartData;
  const shipping = 0;
  const [applyBlossoms, setApplyBlossoms] = useState(false);
  const [percentage, setPercentage] = useState([]);
  const [dollarstotal, setDollarsTotal] = useState(false);

  const walletAmount = props.customer.wallet_amount || 0;
  useEffect(() => {
    getgstbyYear();
  }, []);

  const getgstbyYear = async () => {
    let url = `${ENDPOINTS.GET_GST}`;

    const response = await API.get(url);
    if (response.statusText === "OK") {
      setGST(response.data.data);
    }
  };

  useEffect(() => {
    const fetchPercentage = async () => {
      try {
        const response = await API.get(ENDPOINTS.GET_PERCENTAGE);
        if (response.statusText === "OK") {
          const latestPercentage = response.data.data.data?.percentage || '';
          setPercentage(latestPercentage);
        }
      } catch (error) {
        console.error("Error fetching percentage:", error);
      }
    };
    fetchPercentage();
  }, [applyBlossoms]);


  useEffect(() => {
    const fetchDollars = async () => {
      try {
        const response = await API.get(`${ENDPOINTS.GET_DOLLARS}/${props.customer._id}`);
        if (response.statusText === "OK") {
          const totalDollars = response.data.data.data || '0.00';
          setDollarsTotal(totalDollars);
        }
      } catch (error) {
        console.error("Error fetching dollars:", error);
      }
    };
    fetchDollars();
  }, [applyBlossoms]);


  // const paidItems = (props.cartItems || []).filter(
  //   (item) => !props.freeGiftProducts?.some(
  //       (gift) =>
  //         String(gift.product_id) === String(item.product_id.id)
  //     )
  // );
  
  const paidItems = (props.cartItems || []).filter(
    (item) => !props.freeGiftIds.includes(item._id)
  );

  const subtotalforfreeproduct = paidItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  // Use subtotals if it exists, otherwise use subtotal
  const effectiveSubtotal = subtotalforfreeproduct > 0 ? subtotalforfreeproduct : subtotal;

  // Calculate discount based on the customer discount percentage
  const discountPercent = parseFloat(props.customer.discount?.["$numberDecimal"] || 0);
  const discountforfreeproduct = (effectiveSubtotal * discountPercent) / 100;

  // Determine which subtotal to use
  const baseSubtotal = subtotalforfreeproduct > 0 ? subtotalforfreeproduct : subtotal;

  // Calculate discount accordingly
  const baseDiscount = subtotalforfreeproduct > 0 ? discountforfreeproduct : discount;
  let appliedBlossoms = 0;
  if (applyBlossoms) {
    const remainingAfterDiscount = baseSubtotal - baseDiscount;
    appliedBlossoms = Math.min(walletAmount, remainingAfterDiscount);
  }
  // Calculate GST base
  const taxableAmount = baseSubtotal - baseDiscount - appliedBlossoms + shipping;
  const gstAmount = (taxableAmount * gst) / 100;
  let earned = 0;
  let dollars_earned = 0;

  const grandTotal = taxableAmount + gstAmount;

  if (grandTotal > 0) {
    earned = baseSubtotal - baseDiscount;
    dollars_earned = (earned * percentage) / 100;
  }

  return (
    <div className="cartmain_r customscroll">
      <div className="cart_grandtotal">
        <div className="cart_grandtotal_one">
          <div className="cart_grandtotal_onelist">
            <div className="cart_grandtotal_onelist_l">
              <p>
                <span>{t("subtotal_txt")}</span>
                {/* <CustomCurrencyFormat amount={subtotal} /> */}
                <CustomCurrencyFormat amount={baseSubtotal} />
              </p>
              <p>
                <span>
                  {t("discount_txt")} (
                  {props.customer.discount["$numberDecimal"]}%)
                </span>
                <span>- <CustomCurrencyFormat amount={baseDiscount} /></span>
              </p>
              {applyBlossoms && (
                <p>
                  <span>Blossom Dollars Spent</span>
                  <span>- <CustomCurrencyFormat amount={appliedBlossoms} /></span>
                </p>
              )}
              <p>
                <span>{t("deliveryfee_txt")}</span>
                <span><CustomCurrencyFormat amount={shipping} /></span>
              </p>
              <p>
                <span>
                  {t("gst_txt")} {gst}%
                </span>
                <CustomCurrencyFormat amount={gstAmount} />
              </p>
              {dollars_earned > 0 && (
                <p>
                  <span>Blossom Dollars Earned</span>
                  <span><CustomCurrencyFormat amount={dollars_earned} /></span>
                </p>
              )}
            </div>
            <div className="cart_grandtotal_onelist_r">
              <p>{t("grandtotal_txt")}</p>
              <p>
                <CustomCurrencyFormat amount={grandTotal} />
              </p>
            </div>
          </div>
        </div>
        {props.customer.enable_wallet === 1 && Number(props.customer.wallet_amount) != 0 && (
          <div className="dollars">
            <div className="checkbox-input">
              <div className="checkbox-right">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={applyBlossoms}
                  onChange={(e) => setApplyBlossoms(e.target.checked)}
                />
                <label htmlFor="rememberMe"><img src={dollars} alt="dollars" /><span>Apply Blossom Dollars</span></label>
              </div>
              <div className="checkbox-right2">
                <p>Lifetime Dollars Received</p>
                <p>{`$${dollarstotal}`}</p>
              </div>
            </div>
          </div>
        )}
        {/* <Cartform cartData={props.cartData} /> */}
        <Cartform
          cartData={{
            ...props.cartData,
            dollars_spent: appliedBlossoms,
            dollars_earned: dollars_earned,
            subtotal: baseSubtotal,
            discount: baseDiscount,
            gst: gstAmount,
            grand_total: grandTotal
          }}
          cartItems={props.cartItems}
          freeGiftProducts={props.freeGiftProducts}
          freeGiftIds={props.freeGiftIds}
          customer={props.customer}
        />
      </div>
      <Cartstatus />
    </div>
  );
}

export default Carttotal;
